import React, { Component } from "react";
import Hero from "../Components/Hero";
import CaseStudyPreviewHz from "../Components/CaseStudyPreviewHz";
import caseStudy1 from "../Assets/img/consumerhomesearch/consumersearch.jpg";
import caseStudy2 from "../Assets/img/housesnetapp/housenetmockup-screens.jpg";
import caseStudy3 from "../Assets/img/georgiaaquarium/ga-dive-cover.jpg";
import caseStudy4 from "../Assets/img/cinc-website/cinc-hero.jpg";
import caseStudy5 from "../Assets/img/massemail/mass-message-cover.jpg";
import caseStudy6 from "../Assets/img/maive/maive-hero.jpg";
import caseStudy7 from "../Assets/img/webbuilder/webbuilder-cover.png";
import caseStudy8 from "../Assets/img/affinity/affinity-thumbnail.png";
import caseStudy9 from "../Assets/img/reputation/rep-thumb.jpg";
import shelterManagement from "../Assets/img/design-snippets/sheltermanagement-comp.jpg";
import petJournal from "../Assets/img/design-snippets/petjournal.png";
import leadsRedesign from "../Assets/img/design-snippets/leads-redesign.jpg";
import { motion } from "framer-motion";

class HomeTest extends Component {
  render() {
    return (
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ y: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.75 }}
      >
        
        <Hero />
        <div id="work" class="container">
          <section>
            <h4 className="vertical">Projects</h4>
            <div className="row">
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="Popmenu"
                  title="An AI-powered reputation management experience"
                  desc="Helping restaurant owners save time managing their online reputation with AI"
                  role="Product Designer"
                  caseStudyURL="/case-study/reputation-management"
                  thumbimg={caseStudy9}
                  chips={[
                    "Web",
                    "Mobile app",
                    "User research",
                    "User testing",
                    "Prototyping",
                    "AI-powered",
                  ]}
                  comingSoon={false}
                />
              </div>
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="Affinity Advisors"
                  title="A marketplace for transacting specialty insurance"
                  desc="Creating a B2B specialty insurance marketplace for brokers and agents to speed up policy binding"
                  role="Product Designer"
                  caseStudyURL="/case-study/affinity-advisors"
                  thumbimg={caseStudy8}
                  chips={["Web", "0-1 Product", "Prototyping", "Front-end dev"]}
                  comingSoon={false}
                />
              </div>
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="Popmenu"
                  title="Designing a website builder"
                  desc="Creating a new web builder to deliver an enhanced and streamlined web-building experience for both clients and internal teams."
                  role="Product Designer"
                  caseStudyURL="/case-study/webbuilder"
                  thumbimg={caseStudy7}
                  chips={["Web", "UX research", "User testing", "Prototyping"]}
                  comingSoon={false}
                />
              </div>
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="Maive"
                  title="Creating an AI model marketplace from 0-1"
                  desc="Maive was a startup aspiring to create a marketplace where AI models can be shared between developers"
                  role="UX/UI Designer, Graphic Designer, UI Developer"
                  caseStudyURL="/case-study/maive"
                  thumbimg={caseStudy6}
                  chips={[
                    "Mobile app",
                    "0-1 Product",
                    "Branding",
                    "Prototyping",
                    "Front-end dev",
                  ]}
                  comingSoon={false}
                />
              </div>
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="CINC"
                  title="Redesigning a home search experience"
                  desc="In this case study I walk through the journey of leading a redesign of a home search experience."
                  role="UX/UI Designer, UI Developer"
                  caseStudyURL="/case-study/home-search"
                  thumbimg={caseStudy1}
                  chips={[
                    "UX research",
                    "Strategy",
                    "Prototyping",
                    "Front-end dev",
                    "User testing",
                    "A/B testing",
                  ]}
                  comingSoon={false}
                />
              </div>
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="CINC"
                  title="Etta mobile app"
                  desc="Crafting a national home search app that fostered collaboration between home seekers and real estate agents."
                  role="UX/UI Designer"
                  caseStudyURL="/case-study/housesnet-app"
                  thumbimg={caseStudy2}
                  chips={[
                    "Mobile app",
                    "UX research",
                    "Prototyping",
                    "Usability testing",
                  ]}
                  comingSoon={false}
                />
              </div>
              {/* <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="CINC"
                  title="A mass message wizard"
                  desc="The email compose component wasn't working for mass emails. We needed to create a mass email feature that would accomodate to sending emails to thousands of leads."
                  role="UX/UI Designer"
                  caseStudyURL="/case-study/mass-message-wizard"
                  thumbimg={caseStudy5}
                />
              </div> */}
              <div className="col-sm-12">
                <CaseStudyPreviewHz
                  companyname="Georgia Aquarium"
                  title="DiveOps Portal"
                  desc="Georgia Aquarium wanted to redo their DiveOps portal, where divers managed their dive training and dive logs."
                  role="UX/UI Designer"
                  caseStudyURL="/case-study/georgia-aquarium"
                  thumbimg={caseStudy3}
                  chips={["Web", "Prototyping"]}
                />
              </div>
              {/* <div className="col-sm-6">
                                <CaseStudyPreview title="Redesigning CINC's website" desc="CINC was wanting to rebrand their logo and redesign their website." role="UX/UI Designer, UI Designer" caseStudyURL="/case-study/cinc-website" thumbimg={caseStudy4}/>
                            </div> */}
            </div>
          </section>
        </div>
      </motion.div>
    );
  }
}

export default HomeTest;
